import { MY_INFO } from 'urls';
import { emptySplitApi } from '../createAPI';

emptySplitApi.enhanceEndpoints({ addTagTypes: ['myInfo'] });

export const myInfoApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    myInfo: builder.query({
      query: () => MY_INFO,
      providesTags: ['myInfo']
    })
  })
});

export const { useMyInfoQuery } = myInfoApi;
